import assetPath from '/opt/actions-runner/_work/crate/crate/xinglets/companies/companies/src/assets/svg/free-cover.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')